export const PER_PAGE_DEFAULT = 20;

export const getNumberParameter = (searchParameters: URLSearchParams, parameterName: string): number | undefined => {
  const value = searchParameters.get(parameterName);

  if (value === null) {
    return undefined;
  }

  const number = Number(value);
  return Number.isNaN(number) ? undefined : number;
};
